
<b-row>
  <b-column size="6/12">
    <date-picker
      :key="filterElement.id + '-1'"
      :mode="mode"
      v-model="minDatetime"
      :max="maxDatetime"
      :allow-input="true"
    ></date-picker>
  </b-column>
  <b-column>
    <date-picker
      :key="filterElement.id + '-2'"
      :mode="mode"
      v-model="maxDatetime"
      :min="minDatetime"
      :allow-input="true"
    ></date-picker>
  </b-column>
</b-row>
